import { j as json } from "../../../../chunks/index2.js";
import * as nodemailer from "nodemailer";
import { c as config, g as getBugReportConfig } from "../../../../chunks/mailer.js";
const POST = async ({ request }) => {
  const { title, description, machine } = await request.json();
  const transporter = nodemailer.createTransport(config);
  const options = await getBugReportConfig(title, description, machine);
  await transporter.sendMail(options);
  return json({ success: true });
};
export {
  POST
};
